import FormInput from "~/components/common/form/formInput/FormInput";
import styles from "./EstimateStep5.module.scss";
import classNames from "classnames/bind";
import BaseSelectCustom from "~/components/common/base-select-custom/BaseSelectCustom";
import FormNumber from "~/components/common/form/formNumber/FormNumber";
import { Trash2 } from "lucide-react";
import { DragIcon, EditIcon, PlusIcon } from "~/assets/icons";
import { useEffect, useRef, useState } from "react";
import { InputLabel } from "@mui/material";
import { EstimateModeViewEnum, EstimateUoMOption } from "~/pages/admin/jobs/add-job/constants/add-estimate.constants";
import AddItem from "~/components/common/add-item/AddItem";
import DroppableArea from "~/components/common/drop-drag/DroppableArea";
import BaseBoxContent from "~/components/common/base-box-content/BaseBoxContent";
import FormToggle from "~/components/common/form/formToggle/FormToggle";
import TitleEditor from "~/components/common/form/titleEdit/TitleEditor";
import { useAppDispatch, useAppSelector } from "~/redux/hooks";
import { handleGetEstimateTemplateAuthorization } from "~/thunks/estimate-setting/estimateSettingThunk";
import { IEstimateTemplateAuthorization } from "~/utils/interface/estimateSetting";

const cx = classNames.bind(styles);

const typeUoM = [
    { id: "SQ_FT", label: "SQ_FT" },
    { id: "EA", label: "EA" },
    { id: "LF", label: "LF" },
    { id: "HOUR", label: "HOUR" },
];

interface EstimateStep5Props {
    onChange: (formData: any) => void,
    data: any,
    mode: string,
    errorForm: any,
    onPreview: () => void,
}

interface signer {
    id?: string,
    firstName: string,
    lastName: string,
    email: string,  // "MATERIAL",
}

interface section {
    itemName: string,
    type: string,  // "MATERIAL",
    uom: string,  //"SQ_FT",
    quantity: number,
    unitPrice: number
}

interface quote {
    title: string,
    isVisible: boolean,
    sections: section[]
}

interface quote {
    title: string,
    isVisible: boolean,
    sections: section[]
}

interface productionSelection {
    title: string,
    selections: prodSelectionItem[],
    // selection1FieldName:"",
    // selection1CustomerInput:"",
    // selection1SortOrder:"",

    // selection2FieldName:"",
    // selection2CustomerInput:"",
    // selection2SortOrder:"",

    // selection3FieldName:"",
    // selection3CustomerInput:"",
    // selection3SortOrder:"",
}

interface prodSelectionItem {
    id?: string,
    name: string,
    customer: string,
}

const EstimateStep5 = ({
    onChange,
    data,
    mode,
    errorForm,
    onPreview
}: EstimateStep5Props) => {
    const dispatch = useAppDispatch();
    const { estimateTemplateAuthorization } = useAppSelector((state) => state.estimateSetting);
    const [quantity, setQuantity] = useState(0)

    const [formData, setFormData] = useState<{
        signer: signer,
        signerTitle: string,
        disclaimer: string,
        isDeposit: boolean,
        footerNotes: string,
        optional: quote,
        selection: productionSelection,
        titleStep5: string,
    }>(data)

    const [templateDropdownOpen, setTemplateDropdownOpen] = useState(false);
    const [templatesLoading, setTemplatesLoading] = useState(false);
    const templateDropdownRef = useRef<HTMLDivElement>(null);
    const formDataRef = useRef(formData);

    const [selection, setSelection] = useState<productionSelection>({
        title: "My Product Selections",
        selections: [

        ]
    })


    const [error, setError] = useState({
        companyDescription: '',
        gutter: '',
    });

    const handleUpdateFormData = (update: any) => {
        let data = { ...formData, ...update };
        onChange(data);
        setFormData(data)
    }

    const handleUpdatSignersData = (update: any, index?: number) => {
        let data = { ...formData }
        data.signer = { ...data.signer, ...update };
        onChange(data);
        setFormData(data)
    }

    const handleUpdateTitle = (update: any) => {
        let data = { ...formData, ...update };
        onChange(data);
        setFormData(data)
    }

    const handleSectionUpdateData = (update: any, indexSection: number) => {
        let data = { ...formData };
        data.optional.sections[indexSection] = { ...data.optional.sections[indexSection], ...update };
        // data[key] = value;
        onChange(data);
        setFormData({
            ...formData,
            optional: data.optional
        })
    }

    const handleAddQuote = () => {
        let data = { ...formData };
        // data.signers.push({
        //     firstname: "",
        //     email:"", 
        // })
        onChange(data);
        setFormData({
            ...formData,
            optional: data.optional
        })
    }

    const handleAddSection = () => {
        let data = { ...formData };
        data.optional.sections.push({
            itemName: '',
            type: "MATERIAL",
            uom: '',  //"SQ_FT",
            quantity: 0,
            unitPrice: 0
        })
        setFormData({
            ...formData,
            optional: data.optional
        })
        onChange(data);
    }

    const totalSection = (sections: section[]) => {
        let total = 0;
        sections.forEach((section) => {
            total += section.unitPrice * section.quantity
        })
        return total.toFixed(2)
    }

    const handleRemoveSection = (indexSection: number) => {
        let data = { ...formData.optional };
        data.sections.splice(indexSection, 1)
        setFormData({
            ...formData,
            optional: data
        })
    }

    const onDragItemStart = (e: React.DragEvent, indexSection: number) => {
        e.dataTransfer.setData('index', indexSection.toString());
    };

    const onDropItem = (e: React.DragEvent, indexSection: number) => {
        const from = Number(e.dataTransfer.getData('index'));

        let data = { ...formData.optional };
        // data.sections
        const newItems = [...data.sections];
        const [moved] = newItems.splice(from, 1);
        newItems.splice(indexSection, 0, moved);

        data.sections = newItems;
        // setItems(newItems);

        let newValue = {
            ...formData,
            optional: data
        }

        setFormData(newValue);
        onChange(newValue)
    };


    ///Product Selections
    const prodSelectionUpdateItem = (update: any, index: number) => {
        let data = { ...formData };
        if (!data.selection) {
            data.selection = {
                title: "",
                selections: []
            }
        }

        if (data.selection.selections.length < 3) {
            [1, 2, 3].forEach(() => {
                data.selection.selections.push({ name: "", customer: "" })
            })
        }

        data.selection.selections[index] = { ...data.selection.selections[index], ...update };
        data.selection.selections = data.selection.selections.filter((item, index) => index <= 2)
        setFormData(data);
        onChange(data)
    }

    useEffect(() => {
        formDataRef.current = formData;
    }, [formData]);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (templateDropdownRef.current && !templateDropdownRef.current.contains(event.target as Node)) {
                setTemplateDropdownOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    useEffect(() => {
        let data = { ...formData };
        if (!data.signer) {
            data.signer = {
                firstName: '',
                lastName: '',
                email: '',
            }
        }

        if (!data.optional || data.optional.sections.length == 0) {
            data.optional = {
                title: '',
                isVisible: true,
                sections: [{
                    itemName: "",
                    type: "MATERIAL",
                    uom: "",  //"SQ_FT",
                    quantity: 0,
                    unitPrice: 0
                }]
            }
        }

        if (!data.selection) {
            data.selection = {
                title: "",
                selections: []
            }
        }

        if (data.selection.selections.length < 3) {
            [1, 2, 3].forEach(() => {
                data.selection.selections.push({ name: "", customer: "" })
            })
        }
        data.selection.selections = data.selection.selections.filter((item, index) => index <= 2)
        setFormData(data);
        onChange(data)
    }, [])

    const handleUseTemplateClick = () => {
        const nextOpen = !templateDropdownOpen;
        setTemplateDropdownOpen(nextOpen);
        if (nextOpen) {
            setTemplatesLoading(true);
            dispatch(handleGetEstimateTemplateAuthorization()).finally(() => {
                setTemplatesLoading(false);
            });
        }
    };

    const handleSelectTemplate = (template: IEstimateTemplateAuthorization) => {
        const itemsSorted = [...(template.items ?? [])].sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));
        const selectionsSorted = [...(template.selections ?? [])].sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0));

        const selectionItems = selectionsSorted
            .slice(0, 3)
            .map((s) => ({
                name: s.fieldName ?? "",
                customer: s.customerInput ?? "",
            }));
        while (selectionItems.length < 3) {
            selectionItems.push({ name: "", customer: "" });
        }

        const next = {
            ...formDataRef.current,
            titleStep5: template.estimateTemplate?.templateName ?? formDataRef.current.titleStep5 ?? "",
            disclaimer: template.disclaimer ?? formDataRef.current.disclaimer ?? "",
            isDeposit: template.isDeposit ?? formDataRef.current.isDeposit ?? false,
            footerNotes: template.footer ?? formDataRef.current.footerNotes ?? "",
            optional: {
                title: template.optionalTitle ?? (formDataRef.current.optional?.title || "Optional Upgrades"),
                isVisible: formDataRef.current.optional?.isVisible ?? true,
                sections: itemsSorted.map((item) => ({
                    itemName: item.itemName ?? "",
                    type: item.type ?? "MATERIAL",
                    uom: item.uom ?? "",
                    quantity: Number(item.quantity ?? 0) || 0,
                    unitPrice: Number(item.unitPrice ?? 0) || 0,
                })),
            },
            selection: {
                title: template.selectionsTitle ?? (formDataRef.current.selection?.title || "My Product Selections"),
                selections: selectionItems,
            },
        };

        formDataRef.current = next;
        setFormData(next);
        onChange(next);
        setTemplateDropdownOpen(false);
    };

    return (<div className={cx('estimate-step-container')}>
        <div className={cx('header', 'flex items-center justify-between')}>
            <TitleEditor value={formData.titleStep5}
                name={""}
                placeholder={""}
                inputkey={""}
                isViewMode={mode == EstimateModeViewEnum.VIEW}
                onChange={(value) => {
                    handleUpdateTitle({
                        ...formData,
                        titleStep5: value
                    })
                }}
                styleView={{
                    fontSize: "20px",
                    fontWeight: 700,
                }}
            />
            <div className="flex items-center gap-[16px]" ref={templateDropdownRef}>
                <div className={cx("template-dropdown-wrapper")}>
                    <button
                        type="button"
                        className={cx("left-content-body-menu-item")}
                        onClick={handleUseTemplateClick}
                    >
                        Use Template
                    </button>
                    {templateDropdownOpen && (
                        <div className={cx("template-dropdown")}>
                            {templatesLoading ? (
                                <div className={cx("template-dropdown-loading")}>Loading...</div>
                            ) : (
                                <ul className={cx("template-dropdown-list")}>
                                    {estimateTemplateAuthorization.length === 0 ? (
                                        <li className={cx("template-dropdown-empty")}>No templates</li>
                                    ) : (
                                        estimateTemplateAuthorization.map((template) => (
                                            <li key={template.id}>
                                                <button
                                                    type="button"
                                                    className={cx("template-dropdown-item")}
                                                    onClick={() => handleSelectTemplate(template)}
                                                >
                                                    {template.estimateTemplate?.templateName || "Unnamed template"}
                                                </button>
                                            </li>
                                        ))
                                    )}
                                </ul>
                            )}
                        </div>
                    )}
                </div>

                <button onClick={() => { }} className={cx('page-setting')}>
                    Page Settings
                </button>

                <button onClick={onPreview} className={cx('btn-preview')}>
                    View Page
                </button>
            </div>
        </div>

        <div className={cx('content')}>
            <div className="mb-[20px]">

                <FormInput
                    name={"Disclaimer"}
                    text={"Disclaimer"}
                    isViewMode={mode == EstimateModeViewEnum.VIEW}
                    placeholder={"Disclaimer"}
                    inputkey={"company"}
                    value={formData.disclaimer}
                    height="56px"
                    onChange={(e) => {
                        handleUpdateFormData({ disclaimer: e.target.value })
                    }}
                />
            </div>

            <BaseBoxContent className={cx('section-item')} expanded={true}>
                <div data-slot="header">
                    <div className={cx('section-title')}>
                        <p>Optional Upgrades</p>
                    </div>
                </div>
                <div data-slot="content">
                    <div className={cx('section-item-table')}>
                        <div className={cx('section-item-header')}>
                            <div className="w-[24px]">
                            </div>
                            <div className="w-[28%]">
                                <h3>Item Name</h3>
                            </div>
                            <div className="w-[16%]">
                                <h3>UoM</h3>
                            </div>
                            <div className="w-[16%]">
                                <h3>Quantity</h3>
                            </div>
                            <div className="w-[16%]">
                                <h3>Price</h3>
                            </div>
                            <div className="w-[19%]">
                                <h3>Line Total</h3>
                            </div>
                            {
                                mode != EstimateModeViewEnum.VIEW && <div className="w-[5%]">
                                </div>
                            }

                        </div>
                        <div className={cx('section-item-table-body')}>
                            {
                                <DroppableArea data={formData.optional.sections}
                                    // groupName={"sectionItems" + index}
                                    onChange={(newArray) => {
                                        let data = { ...formData };
                                        data.optional.sections = newArray
                                        setFormData(data);
                                        onChange(data)
                                    }}
                                    renderComponent={(section: any, indexSection: any) => {
                                        let itemError: any = {};
                                        // if(errorForm && errorForm.quotes && errorForm.quotes.quotesList){
                                        //     if(errorForm.quotes.quotesList[index] && errorForm.quotes.quotesList[index].sectionList){
                                        //         if(errorForm.quotes.quotesList[index].sectionList[indexSection]){
                                        //             itemError = errorForm.quotes.quotesList[index].sectionList[indexSection]
                                        //         }
                                        //     }
                                        // }

                                        return (
                                            <div className={cx('section-item-table-row')}                                                 >
                                                <div className={cx('drag-button')}>
                                                    <DragIcon className={cx("drag-icon")} />
                                                </div>
                                                <div className="w-[28%]">
                                                    <FormInput
                                                        name={"itemName"}
                                                        text={""}
                                                        isViewMode={mode == EstimateModeViewEnum.VIEW}
                                                        isViewNoInput={true}
                                                        placeholder={""}
                                                        inputkey={"itemName"}
                                                        value={section.itemName}
                                                        error={
                                                            itemError.itemName ? itemError.itemName : ""
                                                        }
                                                        onChange={(e) => {
                                                            handleSectionUpdateData({
                                                                itemName: e.target.value
                                                            },
                                                                indexSection)
                                                        }}
                                                        height="31px"
                                                    />
                                                </div>
                                                <div className="w-[16%]">
                                                    <BaseSelectCustom
                                                        selectedView={section.uom}
                                                        onViewChange={(viewId) => {
                                                            //  setCurrentFilter(viewId);
                                                            handleSectionUpdateData({
                                                                uom: viewId,
                                                            },
                                                                indexSection)
                                                        }}
                                                        height="36px"
                                                        isViewMode={mode == EstimateModeViewEnum.VIEW}
                                                        isViewNoInput={true}
                                                        error={
                                                            itemError.uom ? itemError.uom : ""
                                                        }
                                                        viewOptions={EstimateUoMOption}
                                                        placeholder="---"
                                                        className={cx({
                                                            'select-filter': true,
                                                            'view-mode': mode == EstimateModeViewEnum.VIEW
                                                        })}
                                                        minWidth={'100px'}
                                                        textAlign="left"
                                                        IconDrop={
                                                            <div className={cx('drop')}>
                                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M11.9994 14.308L8.19141 10.5H15.8074L11.9994 14.308Z" fill="black" />
                                                                </svg>
                                                            </div>
                                                        }
                                                    />
                                                </div>
                                                <div className="w-[16%]">
                                                    <FormInput
                                                        name={"number"}
                                                        text={""}
                                                        value={section.quantity}
                                                        // minValue={0}
                                                        height="31px"
                                                        isViewMode={mode == EstimateModeViewEnum.VIEW}
                                                        isViewNoInput={true}
                                                        error={itemError.quantity ? itemError.quantity : ""}
                                                        onChange={(e) => {
                                                            handleSectionUpdateData({
                                                                quantity: e.target.value
                                                            },
                                                                indexSection);
                                                        }}
                                                        inputkey={""} placeholder={""} />
                                                </div>
                                                <div className="w-[16%]">
                                                    <div className="w-[100px]">
                                                        <FormInput
                                                            name={"company"}
                                                            text={""}
                                                            isViewMode={mode == EstimateModeViewEnum.VIEW}
                                                            isViewNoInput={true}
                                                            placeholder={""}
                                                            inputkey={"company"}
                                                            value={section.unitPrice}
                                                            error={
                                                                itemError.quantity ? itemError.unitPrice : ""
                                                            }
                                                            onChange={(e) => {
                                                                handleSectionUpdateData({
                                                                    unitPrice: e.target.value
                                                                },
                                                                    indexSection)
                                                            }}
                                                            height="31px"
                                                        />
                                                    </div>

                                                </div>
                                                <div className="w-[19%]">
                                                    <div className={cx('total-money')}>
                                                        <h3>${(section.unitPrice * section.quantity).toFixed(2)}</h3>
                                                    </div>

                                                </div>
                                                {
                                                    mode != EstimateModeViewEnum.VIEW && <div className="w-[5%] flex items-center">
                                                        <div className={cx('text-delete')} onClick={() => handleRemoveSection(indexSection)}>
                                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                <path d="M3.33398 3.33398L12.6673 12.6673" stroke="#FA6363" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                                <path d="M3.33269 12.6673L12.666 3.33398" stroke="#FA6363" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                            </svg>
                                                        </div>
                                                    </div>
                                                }
                                            </div>
                                        )
                                    }}
                                />

                            }

                        </div>
                    </div>
                </div>

                <div data-slot="footer">
                    {
                        mode != EstimateModeViewEnum.VIEW && <div className={cx('section-action')}>
                            <AddItem onClick={() => { handleAddSection() }} />
                        </div>
                    }
                    <div className={cx('section-item-footer', {
                        "mt-[20px]": mode == EstimateModeViewEnum.VIEW
                    })}>
                        <div>
                            {/* {
                            errorForm.quotes && 
                            errorForm.quotes.quotesList &&
                            errorForm.quotes.quotesList[index] &&
                            errorForm.quotes.quotesList[index].sections && <p className={cx("error-message")}>{errorForm.quotes.quotesList[index].sections}</p>
                        } */}
                        </div>
                        <div className={cx('total')}>
                            <h4>Section Total</h4>
                            <h3>${totalSection(formData.optional.sections)}</h3>
                        </div>
                    </div>
                </div>

            </BaseBoxContent>

            <div className={cx('deposit')}>
                <div className={"flex items-center justify-between w-full"}>
                    <p className={cx('title')}>Deposit</p>
                    <div>
                        <FormToggle text={""} inputkey={""} value={formData.isDeposit} onChange={(e) => {
                            handleUpdateFormData({ isDeposit: e.newValue })
                        }} />


                    </div>

                </div>
                <div>
                    <p className={cx('help')}>Deposit</p>
                </div>
            </div>


            <div className={cx('template', 'mb-[24px]')}>
                {/* <div className="flex items-center justify-between mb-[16px]">
                        <InputLabel className={cx("form-input-title")}>Enter Disclaimer</InputLabel>
                    </div> */}

                {/* <div>
                        <FormInput 
                            name={"company"} 
                            text={""} 
                            isViewMode={mode == EstimateModeViewEnum.VIEW}
                            placeholder={""} 
                            inputkey={"company"}
                            value={formData.disclaimer}
                            error={errorForm.disclaimer}
                            inputType="textarea"
                            height="85px"
                            onChange={(e)=>{
                                handleUpdateFormData({
                                    disclaimer:e.target.value
                                });
                            }}
                        />
                    </div> */}




                {/* {
                        mode != EstimateModeViewEnum.VIEW && <div className={cx('section-action','mt-[40px]')} onClick={handleAddQuote}>
                            <button className={cx('add-item')}>
                                <PlusIcon className="w-[14px] h-[14px]" />
                                Add Signer
                            </button>
                        </div>
                    }
                    {
                        errorForm.signers &&   errorForm.signers.signers &&  <p className={cx("error-message")}>{errorForm.signers.signers}</p>
                    }
                     */}

            </div>

            <div className="mb-[64px]">
                <div className={cx('primary-signer')}>
                    <strong><h4 className="mb-[4px]">
                        <strong><h4 className="mb-[4px]">Primary Signer</h4></strong>
                    </h4></strong>
                    <h4 className="mb-[20px]">Description</h4>
                </div>
                <div className="flex gap-[36px] mt-[16px]">
                    <FormInput
                        name={"firstName"}
                        text={"First Name *"}
                        isViewMode={mode == EstimateModeViewEnum.VIEW}
                        placeholder={"First Name"}
                        inputkey={"company"}
                        value={formData.signer.firstName}
                        error={
                            errorForm.firstName ?
                                errorForm.firstName : ""
                        }
                        height="56px"
                        onChange={(e) => {
                            handleUpdatSignersData({ firstName: e.target.value })
                        }}
                    />

                    <FormInput
                        name={"lastName"}
                        text={"Last Name *"}
                        isViewMode={mode == EstimateModeViewEnum.VIEW}
                        placeholder={"Last Name"}
                        inputkey={"company"}
                        value={formData.signer.lastName}
                        error={
                            errorForm.lastName ?
                                errorForm.lastName : ""
                        }
                        height="56px"
                        onChange={(e) => {
                            handleUpdatSignersData({ lastName: e.target.value })
                        }}
                    />

                    <FormInput
                        name={"company"}
                        text={"Email Address *"}
                        isViewMode={mode == EstimateModeViewEnum.VIEW}
                        placeholder={"Email Address"}
                        inputkey={"company"}
                        value={formData.signer.email}
                        error={
                            errorForm.email ?
                                errorForm.email : ""
                        }
                        height="56px"
                        onChange={(e) => {
                            handleUpdatSignersData({ email: e.target.value })
                        }}
                    />
                </div>
            </div>

            {
                data.selection && <div>
                    <div className={cx('primary-signer')}>
                        <strong><h4 className="mb-[4px]">
                            <TitleEditor name={""} placeholder={""} inputkey={""} value={formData.selection.title}
                                onChange={(value) => {
                                    let data = { ...formData };
                                    data.selection.title = value
                                    setFormData(data);
                                    onChange(data);
                                }} />
                        </h4></strong>
                        <h4 className="mb-[20px]">Description</h4>
                    </div>
                    <div className="w-full flex flex-col gap-[20px]">
                        <DroppableArea data={formData.selection ? formData.selection.selections : []}
                            onChange={(newArray) => {
                                let data = { ...formData };
                                data.selection.selections = newArray
                                setFormData(data);
                                onChange(data)
                            }}
                            renderComponent={(selection: any, index: number) => (
                                <div className={cx("production-selection")}
                                >
                                    <div className="flex gap-[16px] items-center">
                                        <div className="w-[40px]">
                                            <div className={cx('drag-button')}>
                                                <DragIcon className={cx("drag-icon")} />
                                            </div>
                                        </div>
                                        <div className={cx('title')}>Selection {index + 1}</div>
                                    </div>
                                    <div className="flex gap-[16px]">
                                        <div className="w-[40px]">

                                        </div>
                                        <div className="w-full">
                                            <div className="mb-[20px] w-full">
                                                <FormInput
                                                    name={"item"}
                                                    text={""}
                                                    isViewMode={mode == EstimateModeViewEnum.VIEW}
                                                    placeholder={"Item"}
                                                    inputkey={"customer"}
                                                    value={selection.name}
                                                    height="56px"
                                                    onChange={(e) => {
                                                        prodSelectionUpdateItem({ name: e.target.value }, index)
                                                    }}
                                                />
                                            </div>
                                            <div>
                                                <FormInput
                                                    name={"customer"}
                                                    text={""}
                                                    isViewMode={mode == EstimateModeViewEnum.VIEW}
                                                    placeholder={"Customer Input"}
                                                    inputkey={"customer"}
                                                    value={selection.customer}
                                                    height="56px"
                                                    onChange={(e) => {
                                                        prodSelectionUpdateItem({ customer: e.target.value }, index)
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        />
                    </div>

                </div>
            }





            <div className="mt-[34px]">
                <FormInput
                    name={"company"}
                    text={"Add Footer Note (Optional)"}
                    placeholder={""}
                    isViewMode={mode == EstimateModeViewEnum.VIEW}
                    inputkey={"company"}
                    value={formData.footerNotes}
                    inputType="textarea"
                    error={errorForm.footerNotes}
                    height="85px"
                    onChange={(e) => {
                        handleUpdateFormData({
                            footerNotes: e.target.value
                        });
                    }}
                />
            </div>
        </div>
    </div>)
}

export default EstimateStep5;